export const blockIconsMapsShareLocationNew = (
	<span className='material-symbols-outlined'>share_location</span>
);
